import axios, {CancelToken} from '@/plugin/axios'
import api from '@/api'
const cancelFn: Record<string, (reason?: string) => void> = {}

export const notificationsService = {
  fetchActiveNotifications
}

function fetchActiveNotifications(_appId: string, _regionCodes: string): Promise<any> {
  return promiseWrapper(axios.get(
    api.endpoints.NGPASSPORT_API.ACTIVE_NOTIFICATIONS
      .replace('{appId}', _appId)
      .replace('{regionCodes}', _regionCodes),
    {cancelToken: new CancelToken(function executor(c) { cancelFn['notifications'] = c })}
  ))
}

function promiseWrapper<T = any>(_promise: Promise<any>): Promise<T> {
  return new Promise((resolve, reject) => {
    _promise.then(({data}) => {
      resolve(data)
    }).catch(e => {
      if (e.code === 404) resolve([] as any)
      else reject(e)
    })
  })
}
